import { underlineLinkStyle, internalLinkStyle } from './shared-styles-from-theme-fluent';
import type { CommonStylesOptions } from '../types.d';


export const sharedBudgetGridWrapper = ({
  palette,
}: CommonStylesOptions) => ({
  '& .shared-budget-switch-editor-grid-wrapper': {

    '& .shared-budget-switch-editor-grid-innner-wrapper': {
      marginTop: 8,
      marginLeft: 28,
      marginBottom: 10,

      '& .shared-budget-switch-editor-grid': {
        margin: '8px 0',
        maxHeight: '300px',
        overflow: 'auto',
        width: 600,

        '& .table-container': {
          padding: 1,

          '& table>thead>tr>th, & table>tbody>tr>td': {
            fontWeight: 'normal',
            height: '42px',
            verticalAlign: 'middle',
          },

          '& table>tbody>tr>td:nth-child(1), & table>tbody>tr>td:nth-child(2)': {
            width: '5%',
          },

          '& table>tbody>tr>td:nth-child(3)': {
            width: '50%',
            wordBreak: 'break-all',
          },
          '& table>tbody>tr>td:nth-child(4), & table>tbody>tr>td:nth-child(5)': {
            width: '20%',
            minWidth: 120,
          },

          '& .sort-indicator': {
            paddingLeft: 2,
            verticalAlign: 'baseline',
          },

          '& .grid-cell-text': {
            display: 'inline-block',
          },

          '& .select-row': {
            marginLeft: 0,
            marginTop: 0,

            '&:focus:before': {
              outline: `1px solid ${palette.neutralSecondary}`,
              outlineOffset: 8,
            },
          },

          '& .cell-budget-amount .grid-cell-text': {
            display: 'inline',
          },

          '& .shared-budgets-grid-status-icon': {
            verticalAlign: 'middle',
          },

          '& .glyphicon-arrow-up:before': {
            content: '"\\EE68"',
          },
          '& .glyphicon-arrow-down:before': {
            content: '"\\EE69"',
          },
        },
      },
    },

    '& .shared-budget-switch-editor-selected-budget': {
      paddingLeft: 28,
      ...underlineLinkStyle({ palette, elementLocator: '> a' }),
      '& > a:focus': {
        border: 0,
      },

      '& .margin-rt-five': {
        marginRight: 5,
      },

      '& .shared-budget-switch-editor-selected-budget-edit': {
        verticalAlign: 'middle',
      },
    },

    '& .shared-budget-no-budget-warning': {
      paddingLeft: '33px',
      fontSize: '12px',
    },

    '& .shared-budget-no-selected-budget-warning, .shared-budget-is-not-allowed-warning': {
      paddingLeft: '33px',
    },
  },

  '& .container-budget': {
    padding: [4, 0, 10, 28],

    '& > .row:first-child': {
      display: 'flex',
      alignItems: 'center',
    },

    '& .budget-amount': {
      width: 343,
    },

    '& .form-control-static': {
      padding: 0,
    },

    '& .alert-info.form-group': {
      lineHeight: 1.5,
      margin: '8px 0',
      padding: 8,

      '& .alert-image': {
        marginTop: 3,
        float: 'left',
      },

      '& .alert-info-inline': {
        ...internalLinkStyle({ palette, elementLocator: '> a', isGreyBackground: true }),
        '& a': {
          verticalAlign: 'middle',
        },
        '& > a:focus': {
          border: 0,
        },
      },
    },
  },
});
